import axios from 'axios';

const httpClient = axios.create({
  // baseURL: 'http://localhost:9999',
  baseURL: window.API_BASE_URL,
  //baseURL: 'https://localhost:5001/',
  // baseURL: 'http://selfservice33.appnext.com/v2/api/',
  headers: {
    // 'Content-Type': 'application/json',
    // 'Content-Type': 'application/json; charset=utf-8',
    // Accept: 'application/json',
  },
});

export const addRequestInterceptor = (interceptor) => {
  addInterceptorToInstance(httpClient, interceptor);
};

export const addResponseInterceptor = (interceptor) => {
  httpClient.interceptors.response.use(
    (value) => {
      return interceptor.onFulFilled(value);
    },
    (error) => interceptor.onError(error),
  );
};

const addInterceptorToInstance = (axiosInstance, interceptor) => {
  axiosInstance.interceptors.request.use(
    (value) => interceptor.onConfig(value),
    (error) => interceptor.onError(error),
  );
};

export const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: '' }) =>
  async ({ url, method, data, params }) => {
    try {
      const result = await httpClient({
        url: baseUrl + url,
        params,
        method,
        data,
        withCredentials: true,
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };

export default httpClient;
